import React from "react";
import {
    StyledFeedback,
    StyledImageGrid
} from "./styles";

const Feedback = () => {
    return <StyledFeedback>
        <span className="feedback-pre-headline">DON'T TAKE OUR WORD FOR IT</span>
        <h1 className="feedback-headline">Feedback Hall of Fame</h1>
        <span className="feedback-sub-headline">These are some nice things people who use<br/>Sudowrite have said:</span>

        <StyledImageGrid>
            <img src="/assets/pricing/al-nelson-praise.png" />
            <img src="/assets/pricing/leanne-brainstorm.png" />
            <img src="/assets/pricing/invaluable.png" />
            <img src="/assets/pricing/april-fast.png" />
        </StyledImageGrid>
    </StyledFeedback>;
};

export default Feedback;
